import React from 'react';
import './index.scss';
import PieCharts from './PieCharts';
import { ChartPropsType } from './utils';
import BarAndLineCharts from './BarAndLine';
import SentimentMentionsTable from '../Table';

export default function Index(props: ChartPropsType) {
  if (props.type === 'table')
    return (
      <SentimentMentionsTable
        {...props}
        records={props.data.tableData}
      ></SentimentMentionsTable>
    );
  if (props.type === 'pie') return <PieCharts {...props} />;

  return <BarAndLineCharts {...props}></BarAndLineCharts>;
}
